import { useLang } from '@/i18n';
import EcoTextTc from 'eco-design/sections/eco-text-tc';
import React from 'react';
import styles from './index.module.scss';

interface TCConfig {
    list: {
        title: React.ReactNode;
    }[];
    defaultListLength?: number;
    extraProps?: React.ComponentProps<typeof EcoTextTc>;
}
interface TCProps {
    config?: Partial<TCConfig>;
}
const TC: React.FC<TCProps> = (props) => {
    const { t } = useLang('TC');
    const defaultConfig = {
        list: new Array(props.config?.defaultListLength || 23).fill(null).map((item, index) => ({
            title: t(`title${index}`),
        })),
    };

    const items = props.config?.list || defaultConfig.list;

    return <EcoTextTc className={`${styles.comp} GtmModuleData-section`} {...props.config?.extraProps} items={items} />;
};
export default TC;
